import { render } from "./GlobalSeacrhTag.vue?vue&type=template&id=6ad5e388"
import script from "./GlobalSeacrhTag.vue?vue&type=script&lang=js"
export * from "./GlobalSeacrhTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__